import {
  Button,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Grid
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { updateSelfAction } from 'src/store/actions/StaffActions';
import { TonalitySharp } from '@material-ui/icons';
import { NotificationManager } from 'react-notifications';

function UpdateAdmin({ handleClose, modalData }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleUpdate = async (values) => {
    setLoading(true);
    const response = await dispatch(updateSelfAction(values, profile));
    setLoading(false);
    if (response.status === 1) {
      handleClose();
    }
  };

  return (
    <Formik
      initialValues={{
        fullname: `${modalData?.fullname || ''}`,
        username: `${modalData?.username || ''}`,
        phone: `${modalData?.phone || ''}`
      }}
      validationSchema={Yup.object().shape({
        fullname: Yup.string().trim().max(255).required('Fullname is required'),
        username: Yup.string().trim().max(255),
        phone: Yup.number().required('Phone number is required')
      })}
      onSubmit={(values) => {
        handleUpdate(values);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values
      }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs="12">
                <TextField
                  error={Boolean(touched.fullname && errors.fullname)}
                  fullWidth
                  helperText={touched.fullname && errors.fullname}
                  label="Fullname"
                  margin="dense"
                  name="fullname"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.fullname}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs="12">
                <TextField
                  error={Boolean(touched.username && errors.username)}
                  fullWidth
                  helperText={touched.username && errors.username}
                  label="Username"
                  margin="dense"
                  name="username"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.username}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs="12">
                <TextField
                  error={Boolean(touched.phone && errors.phone)}
                  fullWidth
                  helperText={touched.phone && errors.phone}
                  label="Phone number"
                  margin="dense"
                  name="phone"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="phone"
                  value={values.phone}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              type="submit"
            >
              {loading && <CircularProgress size="1.5rem" />}
              Update Staff
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
}

export default UpdateAdmin;
